import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Fade, Snackbar } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { useParams, useSearchParams } from "react-router-dom";
import { getObtenerPromocion, postDeleteImagenPromocion, postUpdatePosicionImagen, postUpdatePromocion } from "../../../api/ApiService";
import PromocionAddEditImagenComponents from "../../../components/PromocionAddEditImagenComponents";
import ModalDeleteComponents from "../../../components/ModalDeleteComponents";


function PromocionAddImagePage() {
    const [cargando, setCargando] = useState(false);

    const [imagenes, setImagenes] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [previewImages, setPreviewImages] = useState([]); // Almacena las URLs para previsualización
    const [editarImagenes, setEditarImagenes] = useState(false);

    const [detallePromocion, setDetallePromocion] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [deleteselected, setDeleteSelected] = useState(null);


    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);



    const stateToken = useSelector(state => state.reducerGlobal.token);


    const params = useParams();

    const { id } = params;
    // console.log("id", id);


    const [searchParams] = useSearchParams();

    const mode = searchParams.get('mode');
    // console.log("mode", mode);


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleListarDetallePromocion();
                // setTimeout(() => {
                //     setCargando(true);
                // }, 1000);
            }
        }
    }, [id, stateToken]);






    //=================================================================================================funcion para obtener el detalle de la promocion
    const handleListarDetallePromocion = () => {

        getObtenerPromocion(id, stateToken?.access_token)
            .then((response) => {
                // console.log("response-getObtenerPromocion", response);
                setCargando(true);
                setDetallePromocion(response);
                if (response?.imagenes?.length > 0) {
                    // setPreviewImages(response?.imagenes); // Establece las URLs para previsualización
                    // setImagenes(response?.imagenes); // Almacena los archivos originales


                    if (mode === 'ordenar-eliminar') {
                        //ordenar de acuerdo al order_column === "0" ejemplo
                        const sortedImages = response?.imagenes.sort((a, b) => Number(a.orden) - Number(b.orden));
                        setPreviewImages(sortedImages); // Establece las URLs para previsualización
                        setImagenes(sortedImages); // Almacena los archivos originales
                    }



                    setEditarImagenes(true);
                } else {
                    setPreviewImages([]); // Establece las URLs para previsualización
                    setImagenes([]); // Almacena los archivos originales
                    setEditarImagenes(false);
                }



            })
            .catch((error) => {
                console.log("error-getObtenerPromocion", error);
                setPreviewImages([]); // Establece las URLs para previsualización
                setImagenes([]); // Almacena los archivos originales

                setCargando(true);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al obtener la promoción');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };











    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };










    //========================================================= Manejar la carga de nuevas imágenes
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (imagenes.length + files.length > 10) {

            setOpen(true);
            setSeverity('warning');
            setMensaje('Solo puedes subir un máximo de 10 imágenes.');
        }


        //las imagenes deben ser de 720x720
        //validar las dimensiones de las imagenes
        files.filter((file) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            return new Promise((resolve) => {
                img.onload = () => {
                    if (img.width === 720 && img.height === 720) {
                        resolve(true);

                        setPreviewImages((prev) => [...prev, img.src]); // Agrega la imagen a la vista previa
                        setImagenes((prev) => [...prev, file]); // Almacena el archivo original

                        let formData = new FormData();
                        formData.append('file', file);

                    } else {
                        setOpen(true); // Muestra un mensaje de error
                        setSeverity('error');
                        setMensaje('La imagen debe tener dimensiones 720x720 píxeles');
                        resolve(false);
                    }
                };
            });
        });

    };

    //========================================================= Manejar el inicio del arrastre
    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    //========================================================= Manejar el evento de soltar
    const handleDrop = (index) => {
        const updatedPreviews = [...previewImages];
        const updatedFiles = [...imagenes];

        const [draggedPreview] = updatedPreviews.splice(draggedIndex, 1);
        const [draggedFile] = updatedFiles.splice(draggedIndex, 1);

        updatedPreviews.splice(index, 0, draggedPreview);
        updatedFiles.splice(index, 0, draggedFile);

        setPreviewImages(updatedPreviews);
        setImagenes(updatedFiles);
        setDraggedIndex(null);


        //         {
        //     "imagenes": [
        //         {
        //             "id": 244273,
        //             "orden": 3
        //         },
        //         {
        //             "id": 244274,
        //             "orden":2
        //         },
        //         {
        //             "id": 244275,
        //             "orden": 1
        //         }
        //     ]
        // }

        //formatear como el ejemplo de arriba para actualizar el orden de las imagenes
        let body = {
            "imagenes": updatedPreviews?.map((img, index) => ({
                "id": img.id,
                "orden": index + 1
            }))
        };

        // // Aquí puedes manejar la lógica para actualizar el orden de las imágenes en el servidor
        // let body = {
        //     "files_ids": updatedPreviews?.map((img) => img.id),
        //     "removed_ids": []
        // }
        // console.log("body", body);
        // setLoadingGuardar(true);
        // handleUpdatePosicionPromocionApi(body, stateToken?.access_token, id);
    };


    //========================================================= Manejar el evento de arrastrar sobre un elemento
    const handleDragOver = (e) => {
        e.preventDefault(); // Necesario para permitir el evento "drop"
    };



    //========================================================= Eliminar una imagen por el index del arreglo
    const handleDeleteImage = (index) => {
        const updatedPreviews = [...previewImages];
        const updatedFiles = [...imagenes];

        updatedPreviews.splice(index, 1);
        updatedFiles.splice(index, 1);

        setPreviewImages(updatedPreviews);
        setImagenes(updatedFiles);
        //remover la referencia, porque si vuelvo a agregar la misma imagen no se va a agregar porque ya existe en el arreglo, entonces debo remover la referencia para que se pueda agregar de nuevo si se desea
        document.getElementById('file-input').value = null;

        // handleOpenModal(updatedFiles[index], index);
    };









    //==============================================================================================funcion para eliminar la foto o mover la posicion
    const handleApiDeleteImagen = () => {

        postDeleteImagenPromocion(stateToken?.access_token, id, deleteselected?.id)
            .then((response) => {
                // console.log("response-postDeleteImagenPromocion", response);
                setLoadingDelete(false);
                setLoadingGuardar(false);
                // setDeleteSelected(null);
                //remover del arreglo la imagen eliminada
                const updatedPreviews = previewImages.filter((img) => img.id !== deleteselected?.id);
                const updatedFiles = imagenes.filter((file) => file.id !== deleteselected?.id);

                setPreviewImages(updatedPreviews);
                setImagenes(updatedFiles);




                setOpen(true);
                setSeverity('success');
                setMensaje("Imagen eliminada con exito");

                // setTimeout(() => {
                //     handleListarDetallePromocion();

                // }, 1500);

                handleCloseModal();



            })
            .catch((error) => {
                console.log("error-postDeleteImagenPromocion", error);
                setLoadingDelete(false);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al eliminar');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };


    //========================================================= Eliminar una imagen que tiene id
    const handleDeleteImageConId = () => {
        //debo tener esta extrutura para eliminar la imagen
        // let body = {
        //     "files_ids": previewImages?.map((img) => img.id),
        //     "removed_ids": [
        //         deleteselected?.id
        //     ]
        // }
        // console.log("body", body);

        setLoadingDelete(true);
        handleApiDeleteImagen();

    };


    //========================================================= Abrir el modal de confirmación
    const handleOpenModal = (index) => {
        console.log("index", index);
        setOpenModal(true);
        setDeleteSelected(index);
    };


    //========================================================= Cerrar el modal de confirmación
    const handleCloseModal = () => {
        setOpenModal(false);
        setDeleteSelected(null);
    };







    //==============================================================================================funcion para ordenar las imagenes
    const handleUpdatePosicionPromocionApi = (body) => {

        postUpdatePosicionImagen(body, stateToken?.access_token, id)
            .then((response) => {
                // console.log("response-postUpdatePosicionImagen", response);
                setLoadingDelete(false);
                setLoadingGuardar(false);


                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje("Orden actualizado con exito");

                    setTimeout(() => {
                        handleListarDetallePromocion();

                    }, 1500);

                    handleCloseModal();

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdatePosicionImagen", error);
                setLoadingDelete(false);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al actualizar la posición de la imagen');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };





    const handleApiOrdenarImagenes = () => {
        let body = {
            "imagenes": previewImages?.map((img, index) => ({
                "id": img.id,
                "orden": index + 1
            }))
        };
        // console.log("body", body);
        // setLoadingGuardar(true);
        // handleUpdatePosicionPromocionApi(body, stateToken?.access_token, id);

        if(previewImages?.length > 0){
            setLoadingGuardar(true);
            handleUpdatePosicionPromocionApi(body);
        }else{
            setOpen(true);
            setSeverity('warning');
            setMensaje('No hay imágenes para ordenar.');
        }
    };















    //==============================================================================================funcion para agregar las imagenes
    const handleAddImagenesApi = (body) => {

        postUpdatePromocion(id, body, stateToken?.access_token)
            .then((response) => {
                // console.log("response-postUpdatePromocion", response);
                setLoadingDelete(false);
                setLoadingGuardar(false);


                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje("Imágenes agregadas con éxito");

                    setTimeout(() => {
                        handleListarDetallePromocion();

                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdatePromocion", error);
                setLoadingDelete(false);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al agregar las imágenes');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    console.log("previewImages", previewImages);
    const handleApiAgregarImagenes = () => {
        // Aquí puedes manejar la lógica para agregar nuevas imágenes al servidor
        const payload = new FormData();
        imagenes.forEach((file) => {
            payload.append('imagenes[]', file);
        });


        console.log("payload", payload);

        // setLoadingGuardar(true);
        // handleAddImagenesApi(payload)
        if(imagenes.length > 0){
            setLoadingGuardar(true);
            handleAddImagenesApi(payload);
        }else{
            setOpen(true);
            setSeverity('warning');
            setMensaje('No hay nuevas imágenes para agregar.');
        }
    };



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">

                <div className="max-w-7xl mx-auto">
                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <span className="text-2xl font-bold mb-4 block">
                                {/* {id ? `Agregar Imágenes a la Promoción: ${detallePromocion?.titulo}` : ''} */}
                                {id ? mode === 'ordenar-eliminar' ? `Ordenar Imágenes de la Promoción: ${detallePromocion?.titulo}` : `Agregar Imágenes a la Promoción: ${detallePromocion?.titulo}` : ''}
                            </span>

                            <PromocionAddEditImagenComponents
                                id={id}
                                mode={mode}

                                editarImagenes={editarImagenes}
                                previewImages={previewImages}
                                handleFileChange={handleFileChange}
                                handleDragStart={handleDragStart}
                                handleDrop={handleDrop}
                                handleDragOver={handleDragOver}
                                // handleDeleteImage={handleDeleteImage}
                                handleDeleteImage={handleOpenModal}
                                handleDeleteImageIndex={handleDeleteImage}

                                handleApiOrdenarImagenes={handleApiOrdenarImagenes}
                                handleApiAgregarImagenes={handleApiAgregarImagenes}
                            />
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>

            </div>

            <ModalDeleteComponents
                openModal={openModal}
                deleteselected={deleteselected}
                title={'¿Está seguro de eliminar esta imagen?'}
                titleSecundary={deleteselected?.file_name}
                loadingDelete={loadingDelete}

                handleCloseModal={handleCloseModal}
                handleDeleteImage={handleDeleteImageConId}
            />

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default PromocionAddImagePage;